import React from "react";
import { MdFileDownload } from "react-icons/md";
import { IMPORT_TEMPLATES } from "../../config/importTemplates.config";

/**
 * Common Utility: Triggers browser CSV file download using Blobs
 */
const triggerBlobDownload = (contentString, fileName) => {
  const blob = new Blob([contentString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/**
 * Utility: Downloads sample CSV template for a given module
 */
export const downloadSampleCSV = (moduleName) => {
  const config = IMPORT_TEMPLATES[moduleName];

  if (!config) {
    console.error(
      `Import template configuration missing for module: "${moduleName}"`
    );
    return;
  }

  const csvContent = [
    config.headers.join(","),
    ...config.sampleData.map((row) =>
      row
        .map((val) => `"${(val ?? "").toString().replace(/"/g, '""')}"`)
        .join(",")
    ),
  ].join("\n");

  triggerBlobDownload(csvContent, config.fileName);
};

/**
 * Utility: Downloads non-valid rows with their failure reasons
 */
export const downloadFailedRowsCSV = (nonValidRows, customFileName) => {
  if (!nonValidRows || !nonValidRows.length) return;

  const dataKeys = Array.from(
    new Set(nonValidRows.flatMap((item) => Object.keys(item.data || {})))
  );

  const headers = ["Row Number", "Failure Reason", ...dataKeys];

  const csvRows = nonValidRows.map((item) => {
    const rowNum = item.row;
    const reason = `"${(item.reason || "").replace(/"/g, '""')}"`;
    const rowData = dataKeys.map(
      (key) => `"${(item.data?.[key] ?? "").toString().replace(/"/g, '""')}"`
    );
    return [rowNum, reason, ...rowData].join(",");
  });

  const csvString = [headers.join(","), ...csvRows].join("\n");
  const fileName = customFileName || `failed_import_rows_${Date.now()}.csv`;

  triggerBlobDownload(csvString, fileName);
};

/**
 * React Component: Download Sample Template Button
 */
const SampleDownloadButton = ({ module, label = "Sample Template" }) => {
  return (
    <button
      type="button"
      onClick={() => downloadSampleCSV(module)}
      className="btn-primary"
    >
      <MdFileDownload className="text-base text-white-500" />
      {label}
    </button>
  );
};

export default SampleDownloadButton;
